import React from 'react';

interface MenuControlProps {
  isOpen: boolean;
  onToggle: () => void;
}

const MenuIcon: React.FC = () => (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
    </svg>
);

const CloseIcon: React.FC = () => (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
    </svg>
);

export const MenuControl: React.FC<MenuControlProps> = ({ isOpen, onToggle }) => {
  return (
    <div className="bg-white bg-opacity-80 backdrop-blur-sm p-2 rounded-lg shadow-lg border border-gray-200">
      <button
        onClick={onToggle}
        className="w-full h-full flex items-center justify-center bg-white text-gray-700 rounded-md p-2 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-cyan-500 transition-colors"
        aria-label={isOpen ? "Close menu" : "Open menu"}
        aria-expanded={isOpen}
      >
        {isOpen ? <CloseIcon /> : <MenuIcon />}
      </button>
    </div>
  );
};